import React from 'react';
import styled from 'styled-components';
import { updateBool } from '../../../api/studyListApi';
import { toaster } from '../../../helpers/toaster';

const Checkbox = (props) => { 
  const onCheckboxChange = (e) => {
    updateBool(props.data?.id, props.source, (!props.value)).then(res => {
      
      toaster(`Updated ${props.source} on study ${props.data.org_study_id}`,"success");

      props.setValue(!props.value);
    });
  };

  return (
    <CheckboxWrapper>
      <input type='checkbox' checked={props.value} onChange={(e) => onCheckboxChange(e)} />
      {
        props.source === 'published'
          ? props.value ? <i className="fas fa-eye" style={{marginLeft: "5px"}}></i> : <i className="fas fa-eye-slash" style={{marginLeft: "5px"}}></i>
          : props.source === 'featured'
            ? props.value ? <i className="fas fa-star" style={{marginLeft: "5px"}}></i> : ""
            : ""
      }
    </CheckboxWrapper>
  );
};

export default Checkbox;

const CheckboxWrapper = styled.div`
  display: flex;
  padding-top: 5px;
`
